module.exports = __webpack_public_path__ + "static/media/drive-download-20211112T013512Z-001.c3261db1.zip";